/* eslint-disable @typescript-eslint/naming-convention */
export const environment = {
  production: true,
  authConfig: {
    clientID: '__authConfigClientID__',
    domain: '__authConfigDomain__',
    audience: '__authConfigAudience__',
    redirectUri: '__authConfigRedirectUri__',
    scope: 'openid email profile roles read:userinfo companyservice:access',
    inAppRedirects: {
      loggedIn: '/loggedin',
      error: '/',
    },
    logoutUrl: '__logoutUrl__',
  },
  etoUrl: '__etoUrl__',
  speccyApiUrl: '__speccyApiUrl__',
  appInsightsCorrelationDomains: '__appInsightsCorrelationDomains__',
  speccyApiUrlV21: '__speccyApiUrlV21__',
  speccyApiUrlV22: '__speccyApiUrlV22__',
  speccyApiUrlV3: '__speccyApiUrlV3__',
  projectsApiUrl: '__projectsApiUrl__',
  masterKeyApiUrl: '__masterKeyApiUrl__',
  fieldAndSitesApiUrl: '__fieldAndSitesApiUrl__',
  maraudersMapApiUrl: '__maraudersMapApiUrl__',
  preferenceImageSizer: '__preferenceImageSizer__',
  revitDownloadUrl: '__revitDownloadUrl__',
  dynamicsOpportunityLink: '__dynamicsOpportunityLink__',
  dynamicsAllOpportunitiesLink: '__dynamicsAllOpportunitiesLink__',
  flags: {
    reports: JSON.parse('__flagsReports__'),
    viewPlans: JSON.parse('__flagsViewPlans__'),
    trackChanges: JSON.parse('__flagsTrackChanges__'),
    mapData: JSON.parse('__flagsMapData__'),
    mapDataMaraudersMap: JSON.parse('__flagsMapDataMaraudersMap__'),
    shareFiles: JSON.parse('__flagsShareFiles__'),
    punchDoors: JSON.parse('__flagsPunchDoors__'),
    manageSpec: JSON.parse('__flagsManageSpec__'),
    importSpec: JSON.parse('__flagsImportSpec__'),
    preferences: JSON.parse('__flagsPreferences__'),
    revit: JSON.parse('__flagsRevit__'),
    support: JSON.parse('__flagsSupport__'),
    viewPlansSearchDoorTag: JSON.parse('__flagsViewPlansSearchDoorTag__'),
    masterKeying: JSON.parse('__flagsMasterKeying__'),
    manageKeys: JSON.parse('__flagsManageKeys__'),
    manageKeysBeta: JSON.parse('__flagsManageKeysBeta__'),
    bid: JSON.parse('__flagsBid__'),
    order: JSON.parse('__flagsOrder__'),
    detail: JSON.parse('__flagsDetail__'),
    zendesk: JSON.parse('__flagsZendesk__'),
    latestSpecChanges: JSON.parse('__flagsLatestSpecChanges__'),
  },
  bim360: {
    authUrl: '__bim360AuthUrl__',
    baseUrl: '__bim360BaseUrl__',
    clientId: '__bim360ClientId__',
    redirect_uri: '__bim360RedirectUri__',
    scope: '__bim360Scope__',
    url: '__bim360Url__',
  },
   autodeskBuild: {
    authUrl: '__autodeskBuildAuthUrl__',
    apiUrl: '__autodeskBuildApiUrl__',
    clientId: '__autodeskBuildClientId__',
    redirectUri: '__autodeskBuildRedirectUri__',
    scope: '__autodeskBuildScope__',
    url: '__autodeskBuildUrl__',
  },
  planGrid: {
    authUrl: '__planGridAuthUrl__',
    apiUrl: '__planGridApiUrl__',
    clientId: '__planGridClientId__',
    redirectUri: '__planGridRedirectUri__',
    url: '__planGridUrl__',
  },
  proCore: {
    authUrl: '__proCoreAuthUrl__',
    apiUrl: '__proCoreApiUrl__',
    clientId: '__proCoreClientId__',
    redirectUri: '__proCoreRedirectUri__',
    url: '__proCoreUrl__',
  },
  experlogixUrl: '__experlogixUrl__',
  projectUrl: '__projectUrl__',
  cutSheetUrl: '__cutSheetUrl__',
  customCutSheetUrl: '__customCutSheetUrl__',
  notesUrl: '__notesUrl__',
  createNewVersion: '__createNewVersion__',
  profileUrl: '__profileUrl__',
  appInsightsInstrumentationKey: '__appInsightsInstrumentationKey__',
  blobStorageAccountBase: '__blobStorageAccountBase__',
  overturSupportUrl: '__overturSupportUrl__',
  zendeskUrl: '__zendeskUrl__',
  emailNotificationUrl: '__emailNotificationUrl__',
  accessManagementUrl: '__accessManagementUrl__',
  moduleFederationManifestRoute: '__moduleFederationManifestRoute__',
  manageKeysModuleFederationUrl: '__manageKeysModuleFederationUrl__',
  keyingApiUrl: '__keyingApiUrl__'
};
